import React from "react";
import "./MainCard.css";

const MainCard = ({ item, onCardClick, onAddToFeatured, isMobile }) => {
  return (
    <div
      className={`main-card ${isMobile ? "mobile" : "desktop"}`}
      onClick={onCardClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onCardClick();
        }
      }}
    >
      <div className="card-header">
        <h3 className="card-title">{item.title}</h3>
        <button
          className="feature-btn"
          onClick={(e) => {
            e.stopPropagation();
            onAddToFeatured();
          }}
          title="إضافة إلى المميزة"
          aria-label={`إضافة ${item.title} إلى المقالات المميزة`}
        >
          ⭐
        </button>
      </div>
      <div className="card-content">
        <p className="subitems-count">
          عدد العناوين الفرعية: {item.subItems?.length || 0}
        </p>
      </div>
      <div className="card-footer">
        <span className="click-hint">انقر لعرض التفاصيل</span>
      </div>
    </div>
  );
};

export default MainCard;
